import { render, staticRenderFns } from "./filter-posts.vue?vue&type=template&id=5e4eff1b&scoped=true"
import script from "./filter-posts.vue?vue&type=script&lang=js"
export * from "./filter-posts.vue?vue&type=script&lang=js"
import style0 from "./filter-posts.vue?vue&type=style&index=0&id=5e4eff1b&prod&lang=scss&scoped=true"
import style1 from "./filter-posts.vue?vue&type=style&index=1&id=5e4eff1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4eff1b",
  null
  
)

/* custom blocks */
import block0 from "./filter-posts.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports